// extracted by mini-css-extract-plugin
export default {"page":"um-z","landingBackground":"vm-z","nonLandingBackground":"wm-z"};